    <!-- #region Navbar -->
    <nav [ngClass]="lang" class="navbar navbar-expand-lg sticky-top">
      <div class="container">

        <img id="Logo-Nav" alt="Logo" src="../../../../assets/images/logo/logo_side.svg" (click)="home()"
          class="wow fadeInLeft" data-wow-delay="0s" />

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-4"
          aria-controls="navbarSupportedContent-4" aria-expanded="false" aria-label="Toggle navigation">

          <span class="navbar-toggler-icon">
            <i class="fas fa-bars"></i>
          </span>

        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent-4">

          <ul class="navbar-nav" [class.ml-auto]="lang=='en'" [class.mr-auto]="lang=='ar'">

            <li id="home" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show"
              data-wow-delay="0s">
              <a *ngIf="lang=='en'" class="nav-link" [routerLink]="['/']">
                <i class="fas fa-home"></i>
                Home
              </a>
              <a *ngIf="lang=='ar'" class="nav-link" [routerLink]="['/']">
                <i class="fas fa-home"></i>
                الرئيسية
              </a>
            </li>

            <li id="services" class="nav-item" data-wow-delay="0.1s" data-toggle="collapse"
              data-target=".navbar-collapse.show">
              <a *ngIf="lang=='en'" class="nav-link" [routerLink]="['/services']">
                <i class="fab fa-slack-hash"></i>
                Services
              </a>
              <a *ngIf="lang=='ar'" class="nav-link" [routerLink]="['/services']">
                <i class="fab fa-slack-hash"></i>
                خدماتنا
              </a>
            </li>

            <!-- <li class="nav-item wow fadeInLeft" data-wow-delay="0.15s">
              <a class="nav-link" href="#">
                  <i class="fas fa-people-carry"></i>
                Products
              </a>
            </li>

            <li class="nav-item wow fadeInLeft" data-wow-delay="0.15s">
              <a class="nav-link" href="#">
                  <i class="fas fa-handshake"></i>
                Partners
              </a>
            </li>

            <li class="nav-item wow fadeInLeft" data-wow-delay="0.25s">
              <a class="nav-link" href="#">
                <i class="fas fa-search-plus"></i>
                Career
              </a>
            </li> -->

            <li id="about" class="nav-item" data-wow-delay="0.3s" data-toggle="collapse"
              data-target=".navbar-collapse.show">
              <a *ngIf="lang=='en'" class="nav-link" [routerLink]="['/about']">
                <i class="fas fa-info"></i>
                About us
              </a>
              <a *ngIf="lang=='ar'" class="nav-link" [routerLink]="['/about']">
                <i class="fas fa-info"></i>
                من نحن
              </a>
            </li>

            <!-- <li class="nav-item lang" data-wow-delay="0.3s">
              <a *ngIf="lang=='en'" class="nav-link" (click)="changeLang('ar')" data-toggle="collapse"
                data-target=".navbar-collapse.show">
                <i class="fas fa-language"></i>
                عربي
              </a>
              <a *ngIf="lang=='ar'" class="nav-link" (click)="changeLang('en')" style="font-family: HacenAlgeria;"
                data-toggle="collapse" data-target=".navbar-collapse.show">
                <i class="fas fa-language"></i>
                Eng
              </a>
            </li> -->

          </ul>

        </div>

      </div>
    </nav>
    <!-- #endregion -->
